export default "__VITE_ASSET__DOk4L_BV__"